import { gql } from '@apollo/client'

export const GET_ALL_COMPONENTS = gql`
  query AllComponentTaxonomies(
    $str: String
    $state: StateEnumOperationFilterInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [TaxonomyPackagingComponentsGraphQLSortInput!]
  ) {
    state: __type(name: "StateEnum") {
      name
      enumValues {
        name
        description
      }
    }
    componentTaxonomy: __type(name: "TaxonomyPackagingComponentsGraphQL") {
      fields {
        name
        description
      }
    }
    taxonomyPackagingComponents(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        id: { gt: 0 }
        or: [
          { name: { contains: $str } }
          { alias: { contains: $str } }
          { code: { contains: $str } }
          { lastUpdatedName: { contains: $str } }
          { state: $state }
        ]
      }
      order: $order
    ) {
      totalCount
      edges {
        node {
          id
          code
          state
          name
          alias
          isVerified
          verifiedOn
          verifiedByName
          verifiedByEmail
          verificationComments
          researcherName
          researcherEmail
          created
          updated
          userEmail
          lastUpdatedName
          lastPublishedDate
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
